/*
 * @Descripttion: 复购周期模块校验
 * @Author: yang chenglin
 */
//  import { lazy } from 'ice';
 import Form from './Form';
 import utils from '@/common/utils';

 export default {
   data: () => ({
    forLine: '', // 商品分组复购周期
   }),

   validators: {
     forLine: (val) => new Promise((resolve, reject) => {
      try {
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            if (!val[i].day) {
              reject(new Error('复购周期不能为空'));
              break;
            }
          }
          resolve();
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
   },
   components: {
     Form: Form
   }
 }